import styled from "styled-components";

import {
    SchoolOutlined as SchoolOutlinedIcon,
    PersonOutline as PersonOutlineIcon,
    ThumbUpAltOutlined as ThumbUpAltOutlinedIcon,
    ThumbDownAltOutlined as ThumbDownAltOutlinedIcon,
    StarOutline as StarOutlineIcon,
    Star as StarIcon,
} from '@material-ui/icons';

import ProImage from "components/Icons/ProImage";
import EliteImage from "components/Icons/EliteImage";

export const ItemContainer = styled.div<{$isNew: boolean}>`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 1rem 0;
  border-bottom: solid 1px rgba(0, 0, 0, 0.2);
  background-color: ${({$isNew}) => !$isNew ? 'var(--background-info, #F7F7F7)' : 'var(--background-alternate, #FFFAF6)'};
  &:first-child {
    padding-top: 0;
  }
  
  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }
`;

export const TopSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-content: space-between;
`;

export const Image = styled.img`
  object-fit: cover;
  width: 6rem;
  height: 6rem;
  border-radius: 100%;
  
  @media (max-width: 465px) {
    width: 4rem;
    height: 4rem;
  }
`

export const Titles = styled.div<{$isDetailView?: boolean}>`
  width: calc(100% - 7rem);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-content: space-between;
  
  @media (max-width: 465px) {
    width: ${({$isDetailView}) => $isDetailView ? '100%' : 'calc(100% - 4.5rem)'};
    padding: ${({$isDetailView}) => $isDetailView ? '1rem' : '0'};
  }
`;

export const Badge = styled.div`
  width: 24px;
  margin-bottom: 0.25rem;
`;

export const CandidateName = styled.div<{$isDetailView: boolean, $isHidden: boolean}>`
  font-size: ${({$isDetailView}) => $isDetailView ? '1.5rem' : '1rem'};
  padding-right: ${({$isDetailView}) => $isDetailView ? '6rem' : '0'};
  color: ${({$isHidden}) => $isHidden ? 'var(--error-main, #FB7672)' : 'rgba(0, 0, 0, 0.87)'};
  font-weight: 600;
  margin-bottom: 0.25rem;

  @media (max-width: 465px) {
    padding-right: 0;
  }
  @media (max-width: 768px) {
    font-size: 1.15rem;
  }
`;

export const CandidateExperience = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
`

export const StyledProImage = styled(ProImage)`
  height: 24px !important;;
`

export const StyledEliteImage = styled(EliteImage)`
  height: 24px !important;;
`

export const StyledSchoolOutlined = styled(SchoolOutlinedIcon)`
  color: #0B4598;
  width: 18px;
  margin-right: 0.25rem;
`

export const StyledPersonOutlineIcon = styled(PersonOutlineIcon)`
  color: #fff;
  width: 18px;
  margin-right: 0.25rem;
`

const commonBadgeClasses = `
  display: flex;
  align-items: center;
  padding: 0.5rem 0.5rem;
  color: #fff;
  font-weight: 500;
  font-size: 0.75rem;
  border-radius: 0.5rem;
  margin-left: 1rem;

  @media (max-width: 465px) {
    margin-left: 0.5rem;
    font-size: 0.65rem;
    padding: 0.15rem;
  }
`

export const NewCandidateBadge = styled.div<{$isDetailView: boolean}>`
  ${commonBadgeClasses};
  background-color: #13CA82;
`

export const ShortlistedCandidateBadge = styled.div<{$isDetailView: boolean}>`
  ${({$isDetailView}) => $isDetailView ? 'position: absolute; top: 0; right: 0;' : ''}
  ${commonBadgeClasses};
  background-color: #988C81FF;
`

export const DeclinedCandidateBadge = styled.div<{$isDetailView: boolean}>`
  ${({$isDetailView}) => $isDetailView ? 'position: absolute; top: 0; right: 0;' : ''}
  ${commonBadgeClasses};
  background-color: var(--error-main, #FB7672);
`

export const StyledThumbUpAltOutlinedIcon = styled(ThumbUpAltOutlinedIcon)`
  color: #fff;
  width: 18px;
  margin-right: 0.25rem;
`
export const StyledThumbDownAltOutlinedIcon = styled(ThumbDownAltOutlinedIcon)`
  color: #fff;
  width: 18px;
  margin-right: 0.25rem;
`

export const NoApplicationsMessage = styled.div`
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
`

export const DetailViewInfo = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;

  @media (max-width: 768px) {
  gap: 1rem;
`;

export const DetailViewInfoItem = styled.div<{$isGraduationYear?: boolean}>`
    display: flex;
    ${({$isGraduationYear}) => $isGraduationYear ? 'flex-direction: column;' : ''}
    align-items: center;
    gap: 0.25rem;
    height: 44px;
    font-size: 0.75rem;
    color: rgba(0, 0, 0, 0.6);

    @media (max-width: 768px) {
      text-align: center;
    }
`;

export const GraduationYear = styled.div`
    font-size: 1rem;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 600;
`;

export const StarIconActive = styled(StarIcon)`
    color: var(--primary-main, #FB7672);
	margin-right: 9.48px;

    @media (max-width: 465px) {
      margin-right: 2px;
    }
`

export const StarIconInactive = styled(StarOutlineIcon)`
    color: var(--primary-main, #FB7672);
	margin-right: 9.48px;

    @media (max-width: 465px) {
      margin-right: 2px;
    }
`

export const ApplicationListItemContainer = styled.div<{$isNew: boolean}>`
  background-color: ${({$isNew}) => !$isNew ? 'var(--background-info, #F7F7F7)' : 'var(--background-alternate, #FFFAF6)'};
  padding: 1.5rem;
  border-radius: 16px;
  margin: 1rem 0;
  
  @media(min-width: 768px) {
    padding: 1.75rem;
  }
`
